import {
  Box,
  Button,
  Chip,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import LayoutFixHome from "../components/LayoutFixHome";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { RoutesConfig } from "../router/types";
import { addUser } from "../services/clientService";
import { toast } from "react-toastify";

export const AssociarAdmin: React.FC = () => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [emails, setEmails] = useState<string[]>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [failedEmails, setFailedEmails] = useState<any>([]);

  const inputRef = useRef<HTMLInputElement>(null);

  const handleBack = () => {
    navigate(RoutesConfig.CADASTRARUSUARIO.path);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const addEmail = (email: string) => {
    const trimmed = email.trim();
    if (
      trimmed &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed) &&
      !emails.includes(trimmed)
    ) {
      setEmails([...emails, trimmed]);
    }
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
      e.preventDefault();
      if (inputValue) {
        addEmail(inputValue);
        setInputValue("");
      }
    }
    if (e.key === "Backspace" && !inputValue && emails.length) {
      setEmails(emails.slice(0, -1));
    }
  };

  const handleRemove = (email: string) => {
    setEmails(emails.filter((e) => e !== email));
  };

  const traduzirErro = (mensagemOriginal: string) => {
    if (!mensagemOriginal) return "Erro desconhecido.";

    const mapaErros: { [key: string]: string } = {
      "User already exists": "E-mail já cadastrado!",
      "Invalid email format": "Formato de e-mail inválido.",
      "User not authorized": "Usuário não autorizado.",
    };
    return mapaErros[mensagemOriginal] || mensagemOriginal;
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData.getData("text");
    const parts = paste.split(/[\s,;]+/);
    let added = false;
    parts.forEach((part) => {
      const trimmed = part.trim();
      if (
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed) &&
        !emails.includes(trimmed)
      ) {
        setEmails((prev) => [...prev, trimmed]);
        added = true;
      }
    });
    if (added) setInputValue("");
  };

  const handleConcluir = async () => {
    const cnpjBraxcom = "05.533.354/0001-15";
    const type = 1;

    try {
      const results = await Promise.all(
        emails.map(async (email) => {
          try {
            await addUser(email, cnpjBraxcom, type);
            return { email, success: true };
          } catch (error: any) {
            const rawMessage =
              error?.response?.data?.message ||
              error?.message ||
              "Erro desconhecido";
            const message = traduzirErro(rawMessage);

            return { email, success: false, message };
          }
        })
      );

      const allSucceeded = results.every((r) => r.success);
      const failed = results.filter((r) => !r.success);
      setFailedEmails(failed);

      if (allSucceeded) {
        toast.success(
          "Todos os usuários com acesso Admin BRAXCOM foram pré-cadastrados com sucesso!"
        );
        setEmails([]);
        setFailedEmails([]);
        setInputValue("");
        navigate(RoutesConfig.CADASTRARUSUARIO.path);
      } else {
        setEmails(failed.map((f) => f.email));
        toast.error(
          "Alguns usuários admin BRAXCOM não foram cadastrados. Verifique os emails inseridos."
        );
      }
    } catch (error) {
      console.error("Erro inesperado:", error);
      toast.error("Erro inesperado ao cadastrar usuários admin.");
    }
  };

  return (
    <LayoutFixHome>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "29px",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
            marginTop: {
              sm: "75px",
              xs: "75px",
              md: 0,
            },
          }}
        >
          <div onClick={handleBack}>
            <ExpandCircleDownOutlinedIcon
              style={{ transform: "rotate(-270deg)" }}
              sx={{ color: "#0A0C33", height: "30px", width: "30px" }}
            />
          </div>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "#0A0C33" }}
          >
            Associação de Admin
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          border: "1px solid #0A0C33",
          height: {
            xs: "100vh",
            sm: "100vh",
            md: "81vh",
          },
          borderRadius: "15px",
          p: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          flexWrap="wrap"
          sx={{ textAlign: isMobile ? "center" : "left" }}
        >
          <Typography
            sx={{ color: "#0A0C33", fontSize: "22px", fontWeight: 500 }}
          >
            Associados
          </Typography>
          <Typography sx={{ color: "#0A0C33", fontSize: "18px" }}>
            (um link de acesso será enviado para os e-mails realizarem o
            cadastro)
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            width: { md: "45%", xs: "100%", sm: "100%" },
            marginTop: { sm: "16px", xs: "16px", md: "38px" },
            marginBottom: { sm: "16px", xs: "16px", md: "36px" },
            borderRadius: "12px",
            backgroundColor: "#F5F5F5",
            padding: "16px 16px 16px 40px",
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#000",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "24px",
              height: "100%",
              backgroundColor: "#326AFD",
              borderRadius: "12px 0px 0px 12px",
              zIndex: 1,
            }}
          />
          BRAXCOM SERVIÇOS ADUANEIROS
        </Box>

        <Box sx={{ flex: 1 }}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              minHeight: 265,
              maxHeight: 265,
              border: "1px solid #0A0C33",
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1,
              }}
            >
              {emails.map((email, idx) => {
                const error = failedEmails.find((e: any) => e.email === email);

                return (
                  <Tooltip
                    title={error?.message || ""}
                    arrow
                    key={idx}
                    style={{ alignItems: "center" }}
                    PopperProps={{
                      modifiers: [
                        {
                          name: "zIndex",
                          enabled: true,
                          options: { zIndex: 9999 },
                        },
                      ],
                    }}
                  >
                    <Chip
                      label={email}
                      onDelete={() => handleRemove(email)}
                      sx={{
                        mb: 1,
                        backgroundColor: error ? "#ffe6e6" : "#326AFD",
                        color: error ? "#D32F2F" : "white",
                        border: error ? "1px solid #D32F2F" : "none",
                      }}
                    />
                  </Tooltip>
                );
              })}
              <TextField
                name="addAdmin"
                inputRef={inputRef}
                type="email"
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleInputKeyDown}
                onPaste={handlePaste}
                label="Insira o email"
                placeholder="Insira o email"
                variant="standard"
                autoComplete="off"
                sx={{
                  minWidth: 180,
                  mb: 1,
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#326AFD",
                  },
                }}
              />
            </Box>
          </Paper>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            p: 2,
            borderTop: "1px solid #eee",
            background: "#fff",
            borderRadius: "0 0 15px 15px",
          }}
        >
          <Button
            size="large"
            variant="outlined"
            onClick={() => {
              setEmails([]);
              setInputValue("");
              setFailedEmails([]);
            }}
            sx={{
              textTransform: "none",
              borderRadius: "26px",
              border: "1px solid #0A0C33",
              color: "#0A0C33",
            }}
          >
            Limpar
          </Button>
          <Button
            size="large"
            variant="contained"
            onClick={handleConcluir}
            sx={{
              textTransform: "none",
              backgroundColor: "#326AFD",
              borderRadius: "26px",
              fontWeight: 800,
            }}
            disabled={emails.length === 0}
          >
            Concluir
          </Button>
        </Box>
      </Box>
    </LayoutFixHome>
  );
};
